module.exports = __webpack_public_path__ + "img/Credit-Icon-2.9b5261ee.png";